// libraries and utilities
import { put, call, takeEvery } from "redux-saga/effects";
import { ErrorResponse } from "../../interfaces/ErrorResponse";
import { apiGet, BASE_URL, retrieveToken } from "../../store/api";

import * as dokumenKerjasamaActions from "./dokumenKerjasama.actions";
import { DokumenKerjasamaDetailResponse } from "./types";

export function* getDetailDokumenKerjasama(
  action: ReturnType<typeof dokumenKerjasamaActions.getDetailDokumenKerjasamaAsync.request>
) {
  try {
    const token: string = yield retrieveToken();
    const url = BASE_URL + `dokumen/${action.payload.DOK_ID}`;
    const result: Response = yield call(apiGet, url, token);

    if (result.status === 200) {
      const parsed: DokumenKerjasamaDetailResponse = yield call(result.json.bind(result));
      yield put(dokumenKerjasamaActions.getDetailDokumenKerjasamaAsync.success(parsed));
      return; 
    } else {
      const parsed: ErrorResponse = yield call(result.json.bind(result));
      yield put(dokumenKerjasamaActions.getDetailDokumenKerjasamaAsync.failure(parsed));
      return;
    }
  } catch (err) {
    const parsed: ErrorResponse = {
      name: 'Internal server error',
      message: 'Internal server error',
      code: 500,
      status: 500
    }
    yield put(dokumenKerjasamaActions.getDetailDokumenKerjasamaAsync.failure(parsed));
  }
}

export default function* dokumenKerjasamaSagaGetDetail() {
  yield takeEvery(dokumenKerjasamaActions.getDetailDokumenKerjasamaAsync.request, getDetailDokumenKerjasama);
}
